import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import backRed from "../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../components/Modal/SucessModal";
import "./menu.scss";

export default function MenuForm({ edit = false, view = false }) {
  const {
    formState: { errors },
  } = useForm();

  const { id } = useParams();
  const [fields, setFields] = useState({});
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const onSubmit = (fields) => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}health-article-menu/create`,
        fields,
      )
      .then((response) => {
        if (response.data?._id) {
          setSuccess(true);
        } else {
          alert("Fail");
          console.log("failed...");
        }
      });
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Manage Menu and Category", link: "/healtharticlemenu" },
      {
        text: edit ? "Edit Menu" : view ? "View Menu" : "Add New Menu",
        link: "",
      },
    ],
    [],
  );
  const handleUpdateData = () => {
    let item = { name: fields.name, active: fields.active };
    fetch(`${process.env.REACT_APP_API_URL}health-article-menu/update/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    }).then((result) => {
      result.json().then((resp) => {
        setSuccess(true);
      });
    });
  };

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}health-article-menu/get/${id}`)
      .then((response) => {
        setFields(response.data);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    (view || edit) && getMenuData();
  }, []);

  return (
    <div>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <Home> */}
      <div
        onClick={() => navigate("/healtharticlemenu")}
        className="rose back-button"
      >
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <div className="healtharticle">
        <div className="healtharticle-container ps-2">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              edit ? handleUpdateData() : onSubmit(fields);
            }}
          >
            <div className="row mt-5 new-menu ms-1">
              <div className="col">
                <label className="form-label " htmlFor="">
                  Name <span>*</span>
                </label>
                <input
                  className="form-control w-100 input-menu "
                  type="text"
                  name=""
                  id="name"
                  value={fields.name}
                  onChange={(e) =>
                    setFields((prevState) => {
                      return { ...prevState, name: e.target.value };
                    })
                  }
                  placeholder="Enter"
                  disabled={view}
                />
                {errors.name && (
                  <div className={`invalid-feedback d-block`}>
                    Please Enter Name
                  </div>
                )}
              </div>

              <div className="col">
                <label htmlFor="" className="mb-3 ms-3 ">
                  Active Status <span className="star">*</span>
                </label>
                <div className="d-flex ">
                  <div className="form-check form-check-inline">
                    <input
                      className="me-3"
                      type="radio"
                      name="active"
                      id="active"
                      disabled={view}
                      onChange={(e) => {
                        setFields((prevState) => {
                          return { ...prevState, active: true };
                        });
                      }}
                      value={true}
                      checked={fields.active === true ? "checked" : null}
                    />
                    <label className="" htmlFor="inline1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="me-3"
                      type="radio"
                      name="active"
                      id="active"
                      value={false}
                      disabled={view}
                      onChange={(e) => {
                        setFields((prevState) => {
                          return { ...prevState, active: false };
                        });
                      }}
                      checked={fields.active === false ? "checked" : null}
                    />
                    <label className="" htmlFor="inline2">
                      No
                    </label>
                  </div>
                </div>
                {errors.status && (
                  <div className={`invalid-feedback d-block`}>
                    Please Select an Option
                  </div>
                )}
              </div>
            </div>
            {!view && (
              <div className="d-flex justify-content-center">
                <button className="add-button" type="submit">
                  Add
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/healtharticlemenu"}
          name="Health Article Menu"
          post="posted"
        />
      )}
    </div>
  );
}
